import Home from '../views/home/index.vue'
// import test from '../view/test'

const home = [
  {
    path: '/',
    name: '/home',
    component: Home,
    meta: { keepAlive: true }
    // name: 'home',
    // component: Home
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: { keepAlive: true }
  },
]
export default home
